import { inject, Injectable } from '@angular/core';
import { CaseTypeState } from '../../states';
import { Observable } from 'rxjs';
import { tap, map, catchError } from 'rxjs/operators';
import { GetChecklistResult } from './get-checklist.result';
import { ChecklistRepository } from '../../../infrastructure/repositories/checklist.repository';

@Injectable({ providedIn: 'root' })
export class GetChecklistUseCase {
  private readonly repository = inject(ChecklistRepository);
  private readonly state = inject(CaseTypeState);

  /**
   * Executes the use case to get a checklist with a given case type ID.
   * @param caseTypeId - The ID of the case type for which to retrieve the checklist
   * @returns Observable with the result
   */
  public execute(caseTypeId: string): Observable<GetChecklistResult> {
    this.state.setLoadingChecklist(true);
    this.state.clearErrorChecklist();

    return this.repository.getChecklist(caseTypeId).pipe(
      tap(() => {
        this.state.setLoadingChecklist(false);
      }),
      map((details) => ({ details })),
      catchError((error) => {
        if(error?.status !== 404) {
          const errorMessage = error?.error?.message || error?.message || 'Failed to load checklist';
          this.state.setErrorChecklist(errorMessage);
        }
        this.state.setLoadingChecklist(false);
        throw error;
      })
    );
  }
}